import React, { useState, useCallback, useMemo } from 'react';
// import { withRouter } from "react-router";
import { injectIntl, FormattedMessage, WrappedComponentProps } from 'react-intl';
// import { QuestionCircleFilled, UserOutlined } from '@ant-design/icons';
import { Row, Col, Input, Button, Card, notification, /* Tooltip,  */Form, Select, Radio, /* Radio */ } from 'antd';
import { LOGIN_URL } from './login-util';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { http_props_type, http_request_new } from '../../http-worker/http-func';
import { VisibleDelayed } from '../../shared-functions';
import { DrawerDelayedToShowEmail } from './shared-functions';
import { UserOutlined } from '@ant-design/icons';

export type login_props_type = RouteComponentProps<any> & WrappedComponentProps<'intl'> & http_props_type & {
  sso_path?: string,
  setting_params?: any,
  logo_style?: React.CSSProperties
};

// const DrawerDelayedToShow = (props: {
//   drawer_visible: 1 | undefined;
//   set_drawer_visible: React.Dispatch<React.SetStateAction<1 | undefined>>;
//   intl: IntlShape;
// }) => {
//   const handle_info_close = useCallback(() => {
//     props.set_drawer_visible(undefined);
//   }, [props.set_drawer_visible]);

//   return (
//     <Drawer
//       title={props.intl.formatMessage({ id: 'send_pwd_email' })}
//       placement='bottom'
//       onClose={handle_info_close}
//       visible={!!VisibleDelayedInner(props.drawer_visible)}
//       height={170}
//       headerStyle={{ textAlign: 'center' }}
//       mask={false}
//     >
//       <p className='retrieve-info-content'>
//         <FormattedMessage id='send_pwd_email_sub'></FormattedMessage>
//       </p>
//     </Drawer>
//   );
// };

export const ForgotPwd = withRouter(
  injectIntl((props: login_props_type) => {
    const [button_loading, set_button_loading]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false);
    const [drawer_visible, set_drawer_visible]: [1 | undefined, React.Dispatch<React.SetStateAction<1 | undefined>>] = useState<1 | undefined>();
    const [disabled, set_disabled]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(true);
    const [mode, set_mode] = useState('email');
    const { history, intl } = props;
    const logo_style = useMemo(() => props.logo_style, [props.logo_style])
    const [form] = Form.useForm();
    const { getFieldsValue } = form;
    const sso_path = useMemo(() => props.sso_path?.replace(/^\//, '') || 'v4.0', [props.sso_path]);
    // const setting_params = useMemo(() => props.setting_params, [props.setting_params])
    const handleSubmit = useCallback(async (): Promise<void> => {
      const { username } = getFieldsValue();
      set_button_loading(true);
      // 请求接口
      if (mode === 'email') {
        const send_res: any = await http_request_new({
          key: 'pwdresetemail',
          props: {
            history: props.history,
            redirect_url: props.redirect_url,
            log_out: props.log_out
          },
          url: `/${sso_path}/users/${username}/pwdresetemail`,
          method: 0,
          no_refresh: 1,
          custom_warning: (response: any) => {
            const { code, message } = response;
            if (code >= 400) {
              notification.warning({
                message: intl.formatMessage({ id: 'warning' }),
                description: message
              });
            }
          }
        });
        set_button_loading(false);
        if (send_res && !send_res.code) {
          notification.success({
            message: intl.formatMessage({ id: 'success' }),
            description: intl.formatMessage({ id: 'send_pwd_email_success' })
          });
          setTimeout(() => {
            history.push({ pathname: LOGIN_URL.resetPwd, state: { username: username, mode: mode } });
          }, 5000);
        }
      } else {
        const { phoneNumber } = getFieldsValue();
        const prefix = '86';
        const send_res: any = await fetch(`/v4.0/users/+${prefix}${phoneNumber}/pwdresetsms`);
        set_button_loading(false);
        if (send_res && send_res.status) {
          const { status } = send_res;
          if (200 === status) {
            notification.success({
              message: intl.formatMessage({ id: 'success' }),
              description: intl.formatMessage({ id: 'send_pwd_phone_success' })
            });
            setTimeout(() => {
              history.push({ pathname: LOGIN_URL.resetPwd, state: { username: username, mode: mode } });
            }, 5000);
          } else {
            const data = await send_res.json();
            notification.warning({
              message: intl.formatMessage({ id: 'warning' }),
              description: data.message
            });
          }
        }
      }
    }, [mode, props.history, props.redirect_url, props.log_out, intl, getFieldsValue, history, sso_path]);

    const to_login = useCallback(() => {
      const redirectUri = sessionStorage.getItem('forSsoHomePath');
      if (redirectUri) {
        sessionStorage.removeItem('forSsoHomePath');
        window.location.href = redirectUri;
        return;
      }
      history.push(LOGIN_URL.signIn);
    }, [history]);

    // const handle_click_info = useCallback(() => {
    //   set_drawer_visible(1);
    // }, []);

    const handle_mode_change = useCallback(
      (e: any) => {
        set_mode(e.target.value);
        set_disabled(true);
        e.target.value === 'phone' && form.resetFields(['phoneNumber', 'username'])
      },
      [form]
    );

    const changeValues = useCallback((_changedFields: any[], allFields: any[]) => {
      const current_mode = allFields?.find((f: any) => f.name?.[0] === 'mode').value;
      if (current_mode === 'email') {
        const username = allFields?.find((f: any) => f.name?.[0] === 'username');
        set_disabled(username.errors?.length > 0)
      }
    }, [])

    const format_country_data = useCallback((data: any) => {
      return data.map((item: any) => {
        return {
          key: item.country_code,
          value: item.country_code,
          text: item.name_en
        };
      });
    }, []);

    const handle_check_phone = useCallback(
      async (_rule: any, value: any) => {
        const phone_reg = /^[+-]?\d+$/;
        if (phone_reg.test(value)) {
          const result: any = await (await fetch(`/v4.0/validators/phones/+86${value}/username`)).json();
          if (!result?.valid) {
            set_disabled(true);
            return Promise.reject(intl.formatMessage({id: 'pl_correct_phone'}));
          } else {
            if (!result?.username) {
              set_disabled(true);
              return Promise.reject(intl.formatMessage({id: 'unbound_user'}));
            } else {
              set_disabled(false);
              form.setFieldsValue({username: result?.username})
            }
          }
        } else {
          set_disabled(true);
          if (value) {
            return Promise.reject(intl.formatMessage({id: 'pl_correct_phone'}));
          } else {
            return Promise.resolve();
          }
        }
      },
      [form, intl]
    );
    const parseSelect = useCallback((data: any) => {
      return Array.isArray(data)
        ? data.map((item: any) => {
            const { key, value, text } = item;
            return (
              <Select.Option value={value} key={key}>
                {` ${text}`}
              </Select.Option>
            );
          })
        : [];
    }, []);

    const country_code = useMemo(
      () => [
        {
          name_en: 'China',
          name_zh: '中国',
          country_code: 'CN',
          phone_perfix: '86'
        }
      ],
      []
    );

    const contactPhonePrefixSelector = useMemo(() => {
      return (
        <Form.Item name='regionCode' noStyle initialValue={'CN'}>
          <Select showSearch placeholder='Select a country or region' optionFilterProp='children' style={{ width: '120px' }} disabled={true}>
            {parseSelect(format_country_data(country_code))}
          </Select>
        </Form.Item>
      );
    }, [parseSelect, country_code, format_country_data]);

    const form_items = useMemo(() => ([
      <Form.Item name='username' rules={mode === 'email' ? [
          {required: true, message: intl.formatMessage({ id: 'p_i_username_e' })},
          {type: 'email', message: intl.formatMessage({id: 'pl_correct_email'})}
        ]: []}>
          <Input
            disabled={mode === 'phone'}
            prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
            placeholder={intl.formatMessage({ id: 'email_address' })}
            size='large'
          />
      </Form.Item>,
      <Form.Item
        name='phoneNumber'
        rules={[{ validator: handle_check_phone }]}
        dependencies={['regionCode']}
        validateFirst={true}
        validateTrigger={['onBlur', 'onPressEnter']}
      >
        <Input size='large' placeholder={intl.formatMessage({ id: 'p_i_phone' })} addonBefore={contactPhonePrefixSelector} autoComplete='off' />
      </Form.Item>
    ]), [mode, contactPhonePrefixSelector, handle_check_phone, intl])

    return (
      <Row className='retrieve-password-content' justify='center' align='middle'>
        <Col span={24}>
          <Card className='retrieve-password-box'>
            <Row className="logo-1" style={logo_style ? logo_style : {}}/>
            <Row className='box-title'>
              <FormattedMessage id='forget_pwd'></FormattedMessage>
            </Row>
            <Row className='box-subtitle'>
              <Col span={24}>
                {/* <FormattedMessage id='retrieve_password_sub'></FormattedMessage>&nbsp;
                <Tooltip title={intl.formatMessage({ id: 'help' })}>
                  <QuestionCircleFilled style={{ color: '#1890ff' }} onClick={handle_click_info} />
                </Tooltip> */}
                <FormattedMessage id="enter_email_to_reset_pwd" />
              </Col>
            </Row>

            <Form className='login-form' onFieldsChange={changeValues} onFinish={handleSubmit} form={form}>
              <Form.Item initialValue='email' name='mode'>
                <Radio.Group onChange={handle_mode_change} buttonStyle='solid'>
                  <Radio.Button value='email'>
                    <FormattedMessage id='email'></FormattedMessage>
                  </Radio.Button>
                  <Radio.Button value='phone'>
                    <FormattedMessage id='phone'></FormattedMessage>
                  </Radio.Button>
                </Radio.Group>
              </Form.Item>
              {
                mode === 'email' ? form_items[0] : <>
                  {form_items[1]}
                  {form_items[0]}
                </>
              }
              {/* {mode === 'email' && setting_params?.loginAuthEnable && <span className={'no-bind-email-desc'}><FormattedMessage id={'no_bind_email_desc'}/></span>} */}
              <Form.Item>
                <Row justify='end' align='bottom'>
                  <Button type='primary' size='large' htmlType='submit' className='form-submit-button' loading={button_loading} disabled={disabled}>
                    <FormattedMessage id='reset_pwd'/>
                  </Button>
                </Row>
              </Form.Item>
            </Form>
            <Row justify='center'>
              <div className="divider m-24" />
              <span className='primary-link' onClick={to_login}>
                <FormattedMessage id='return_to_log_in'></FormattedMessage>
              </span>
            </Row>
          </Card>
          {!!VisibleDelayed(drawer_visible) && (
            <DrawerDelayedToShowEmail {...{ intl, drawer_visible, set_drawer_visible, title: 'send_pwd_email', height: 170, message: 'send_pwd_email_sub' }} />
          )}
        </Col>
      </Row>
    );
  })
);
